"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationStepper = void 0;
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useRecommendationStepper = () => {
  const steps = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationsSteps);
  const currentStep = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationCurrentStep);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const onNextStepper = () => {
    dispatch((0, _recommendationActions.goToNextStep)());
  };
  const onBackStepper = () => {
    dispatch((0, _recommendationActions.goToPreviousStep)());
  };
  const isLastStep = currentStep === steps.length;
  const isFirstStep = currentStep === 1;
  const currentStepObject = steps[currentStep - 1];
  return {
    steps,
    currentStep,
    onNextStepper,
    onBackStepper,
    isLastStep,
    isFirstStep,
    currentStepObject
  };
};
exports.useRecommendationStepper = useRecommendationStepper;